import React, { forwardRef } from "react";
import { TextInput } from "react-native"
import { useCssStyle } from "../../customHook/getCssStyle"


export const CustomTextInput = forwardRef(({style={}, value, onChangeText, placeholder, autocomplete, ...restProps}, ref) => {


    const getStyles = useCssStyle();

    const customStyle = getStyles(['input', style]);

    return (
        <TextInput 
            ref={ref}
            {...restProps}
            style={customStyle}
            value={value}
            onChangeText={onChangeText}
            placeholder={placeholder}
            autoComplete={autocomplete}
            selectionColor={customStyle.selectionColor}
            placeholderTextColor="gray"
        />
    )
});